import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessIntrealParamStatus: 'idle',
    startProcessIntrealParamError: undefined as any,
    loadUserParamsProcessIntrealParamStatus: 'idle',
    loadUserParamsProcessIntrealParamError: undefined as any,

    processIntrealParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessIntrealParam = createAsyncThunk('processIntrealParamSlice/startProcessIntrealParam', async ({ processIntrealParam }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessIntrealParam/`,
        prepareData(processIntrealParam),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessIntrealParamStatus } = getState().processIntrealParamSlice
        return startProcessIntrealParamStatus !== 'pending'
    }
})

export const loadUserParamsProcessIntrealParam = createAsyncThunk('processIntrealParamSlice/loadUserParamsProcessIntrealParam', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessIntrealParam/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessIntrealParamStatus } = getState().processIntrealParamSlice
        return loadUserParamsProcessIntrealParamStatus !== 'pending'
    }
})

const ProcessIntrealParamSlice = createSlice({
    name: 'processIntrealParamSlice',
    initialState,
    reducers: {
        resetstartProcessIntrealParam: (state) => {
            state.job = undefined
            state.startProcessIntrealParamError = undefined
        },
        resetstartProcessIntrealParamError: (state) => {
            state.startProcessIntrealParamError = undefined
        },
        resetloadUserParamsProcessIntrealParam: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessIntrealParamError = undefined
        },
        resetloadUserParamsProcessIntrealParamError: (state) => {
            state.loadUserParamsProcessIntrealParamError = undefined
        },
        removeFromProcessIntrealParamListById: (state, action) => {
            state.processIntrealParamList = state.processIntrealParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessIntrealParamListByIds: (state, action) => {
            state.processIntrealParamList = state.processIntrealParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processIntrealParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessIntrealParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processIntrealParamList = []
            state.startProcessIntrealParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessIntrealParam.pending, (state) => {
            state.startProcessIntrealParamStatus = 'pending'
            state.startProcessIntrealParamError = undefined
        })
        builder.addCase(startProcessIntrealParam.fulfilled, (state, action) => {
            state.startProcessIntrealParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessIntrealParam.rejected, (state, action) => {
            state.startProcessIntrealParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessIntrealParamError = action.error.message
            } else {
                state.startProcessIntrealParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessIntrealParam.pending, (state) => {
            state.loadUserParamsProcessIntrealParamStatus = 'pending'
            state.loadUserParamsProcessIntrealParamError = undefined
        })
        builder.addCase(loadUserParamsProcessIntrealParam.fulfilled, (state, action) => {
            state.loadUserParamsProcessIntrealParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessIntrealParam.rejected, (state, action) => {
            state.loadUserParamsProcessIntrealParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessIntrealParamError = action.error.message
            } else {
                state.loadUserParamsProcessIntrealParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessIntrealParam,
    resetstartProcessIntrealParamError,
    resetloadUserParamsProcessIntrealParam,
    resetloadUserParamsProcessIntrealParamError,
    removeFromProcessIntrealParamListById,
    removeFromProcessIntrealParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessIntrealParamSlice.actions
export default ProcessIntrealParamSlice.reducer
